import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { Order, OrderSearchFilters } from "../../types/order";
import { searchOrdersApi } from "../../api/ordersApi";
import type { PaginationParam, PaginationResponse } from "../../types/paginationResponse";

interface OrderState {
  orders: Order[];
  loading: boolean;
  error: string | null;
  pagination: PaginationResponse | null;
}

const initialState: OrderState = {
  orders: [],
  loading: false,
  error: null,
  pagination: null,
};

export const searchOrders = createAsyncThunk<
  { orders: Order[]; pagination: PaginationResponse },
  { filters?: OrderSearchFilters; pagination?: PaginationParam },
  { rejectValue: string }
>("orders/searchOrders", async ({ filters, pagination }, { rejectWithValue }) => {
  try {
    return await searchOrdersApi(filters, pagination);
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || "Failed to search orders");
  }
});

const orderSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    clearOrdersError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = action.payload.orders;
        state.pagination = action.payload.pagination;
      })
      .addCase(searchOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to search orders";
      });
  },
});

export const { clearOrdersError } = orderSlice.actions;
export default orderSlice.reducer;
